/**
 * @generated SignedSource<<9d609566922f1c1690ae2b3fec7d0166>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreatorContent_nftAuction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileAuctionDetails_nftAuction">;
  readonly " $fragmentType": "CreatorContent_nftAuction";
};
export type CreatorContent_nftAuction$key = {
  readonly " $data"?: CreatorContent_nftAuction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreatorContent_nftAuction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreatorContent_nftAuction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileAuctionDetails_nftAuction"
    }
  ],
  "type": "NftAuction",
  "abstractKey": null
};

(node as any).hash = "6ad20e14795433c4e0decc8374ac2a39";

export default node;
